import React, { useEffect, useState } from "react";
import MdHeading from "../Components/MdHeading";
import TableComp from "../Components/TableComp";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DatePicker, Typography } from "antd";
import { formatTime } from "../Components/Global";
import { fetchUserReports } from "../Toolkit/AllUsersSlice";
dayjs.extend(customParseFormat);
const { Text } = Typography;
const { RangePicker } = DatePicker;

const SingleUserMonthlyReport = () => {
  const { userId, employeeId } = useParams();
  const dispatch = useDispatch();
  const employeeReportList = useSelector(
    (state) => state?.alluser?.employeeReportList
  );
  const employeeListLoading = useSelector(
    (state) => state?.alluser?.employeeListLoading
  );
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);

  useEffect(() => {
    let data = {
      requesterId: userId,
      startDate: dayjs(dateRange?.[0]).format("YYYY-MM-DD"),
      endDate: dayjs(dateRange?.[1]).format("YYYY-MM-DD"),
      userIds: [employeeId],
    };
    dispatch(fetchUserReports(data));
  }, [dispatch, dateRange]);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: 80,
    },
    {
      field: "userName",
      headerName: "User name",
      width: 240,
    },
    {
      field: "userEmail",
      headerName: "User email",
      width: 240,
    },
    {
      field: "date",
      headerName: "Date",
      width: 150,
      renderCell: (props) => (
        <Text>{dayjs(props?.row?.date).format("YYYY-MM-DD")}</Text>
      ),
    },
    {
      field: "totalTime",
      headerName: "Total working time",
      width: 150,
      renderCell: (props) => <p>{props?.row?.totalTime}</p>,
    },
    {
      field: "present",
      headerName: "User present",
      width: 150,
      renderCell: (props) => (
        <p>{props?.row?.present ? "Present" : "Absent"}</p>
      ),
    },
    {
      field: "loginTime",
      headerName: "Login time",
      width: 150,
      renderCell: (props) => <Text>{formatTime(props?.row?.loginTime)}</Text>,
    },
    {
      field: "logoutTime",
      headerName: "Left time",
      width: 150,
      renderCell: (props) => <Text>{formatTime(props?.row?.logoutTime)}</Text>,
    },
    {
      field: "productiveTime",
      headerName: "Productive time",
      width: 150,
    },
  ];

  return (
    <>
      <div className="align-between" style={{ marginBottom: 8 }}>
        <MdHeading data={`User report`} />
        <div>
          <RangePicker
            style={{ width: "100%" }}
            value={dateRange}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
            onChange={(e) => setDateRange(e)}
          />
        </div>
      </div>

      <TableComp
        error={employeeListLoading === "error"}
        loading={employeeListLoading === "pending"}
        data={employeeReportList}
        col={columns}
      />
    </>
  );
};

export default SingleUserMonthlyReport;
